import text from "../../assets/header1.png";
import navbar from "../../assets/Nav Bar.png";
import forward from "../../assets/Forward.png";
import React from "react";
import review from "../../assets/review.png";

interface FoodPreviewProps {
  image: File | null;
  foodName: string;
  price: string | number;
  phoneNumber: string;
  location: string;
  restaurantName: string;
  top: string;
  heart: string;
  category?: string[]; 
}

const FoodPreview: React.FC<FoodPreviewProps> = ({
  image,
  foodName,
  price,
  phoneNumber,
  location,
  restaurantName,
  top,
  heart,
  category = [],
}) => {
  return (
    <div className="hidden md:flex justify-center items-center w-1/3">
      <div
        className="relative rounded-[20px] overflow-hidden shadow-2xl"
        style={{ width: "280px", height: "600px" }}
      >
        <img
          src={top}
          alt="Status Bar"
          className="absolute top-0 left-0 w-full object-contain z-10"
        />

        <img
          src={text}
          alt="Header"
          className="absolute left-1/2 transform -translate-x-1/2 z-20 object-contain"
          style={{ top: "7%", width: "50%" }}
        />

        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: "url('/BG.png')" }}
        ></div>

        {image && (
          <>
            {/* Top main card */}
            <div
              className="absolute top-[17%] left-4 right-4 mx-auto rounded-2xl shadow-lg overflow-hidden"
              style={{ width: "250px", height: "330px" }}
            >
              <img
                src={review}
                alt="Review Icon"
                className="absolute top-2 left-3 w-50 h-4 z-20"
              />

              <img
                src={URL.createObjectURL(image)}
                alt="Uploaded Food"
                className="w-full h-full object-fill"
              />

              <img
                src={forward}
                alt="Forward Icon"
                className="absolute top-2 right-2 w-5 h-5 z-20"
              />

              {foodName &&
                restaurantName &&
                price &&
                phoneNumber &&
                location && (
                  <div className="absolute bottom-0 left-0 right-0 p-3 text-white bg-gradient-to-t from-black/60 to-transparent rounded-b-2xl">
                    <div className="flex flex-col mb-1">
                      {category.length > 0 && (
                        <p className="text-xs mb-1 opacity-80">
                          #{category.join(" #")}
                        </p>
                      )}
                      <div className="flex justify-between items-center">
                        <h1 className="font-bold text-base break-words w-[82%]">
                          {foodName}
                        </h1>
                        <span className="font-bold text-base w-[15%] text-right">
                          {price}$
                        </span>
                      </div>
                    </div>

                    <div className="flex justify-between items-center text-xs opacity-90">
                      <div className="w-[82%] break-words">
                        <p>{restaurantName}</p>
                        <p>{phoneNumber}</p>
                        <p>{location}</p>
                      </div>
                      <span className="w-[15%] flex justify-end">
                        <img src={heart} alt="Heart" className="w-5 h-5" />
                      </span>
                    </div>
                  </div>
                )}
            </div>

            {/* Bottom card (blurred duplicate look) */}
            <div
              className="absolute bottom-0 left-4 right-4 mx-auto rounded-2xl shadow-lg overflow-hidden"
              style={{
                width: "250px",
                height: "330px",
                transform: "translateY(70%)",
                zIndex: 0,
              }}
            >
              <img
                src={review}
                alt="Review Icon"
                className="absolute top-2 left-3 w-50 h-4 z-20"
              />

              <img
                src={URL.createObjectURL(image)}
                alt="Uploaded Food"
                className="w-full h-full object-fill"
              />

              <img
                src={forward}
                alt="Forward Icon"
                className="absolute top-2 right-2 w-5 h-5 z-20"
              />
            </div>
          </>
        )}

        <img
          src={navbar}
          alt="Navbar"
          className="absolute bottom-0 left-0 w-full object-contain z-50"
        />
      </div>
    </div>
  );
};

export default FoodPreview;
